const TARGET_RATIOS = [1, 1.5, 2, 2.5, 3, 3.5, 4, 5, 6, 7];

function roundPrice(value) {
  return Number(Number(value || 0).toFixed(2));
}

function buildTargetRatioRange(startRatio, endRatio, step = 0.5) {
  const start = Number(startRatio);
  const end = Number(endRatio);
  if (!Number.isFinite(start) || !Number.isFinite(end)) return [];

  const lowerBound = Math.min(start, end);
  const upperBound = Math.max(start, end);
  const ratios = [];

  for (let ratio = lowerBound; ratio <= upperBound + 0.0001; ratio += step) {
    const normalizedRatio = Number(ratio.toFixed(1));
    if (TARGET_RATIOS.includes(normalizedRatio)) {
      ratios.push(normalizedRatio);
    }
  }

  return ratios;
}

function buildTargetPrices(entryPrice, stoplossPrice, orderType = 'BUY', ratios = TARGET_RATIOS) {
  const entry = Number(entryPrice);
  const stoploss = Number(stoplossPrice);
  if (!Number.isFinite(entry) || !Number.isFinite(stoploss)) return [];

  const risk = Math.abs(entry - stoploss);
  if (!risk) return [];

  const direction = String(orderType).toUpperCase() === 'SELL' ? -1 : 1;

  return ratios.map((ratio) => ({
    ratio,
    price: roundPrice(entry + (direction * risk * ratio)),
  }));
}

function formatRatio(ratio) {
  return `1:${Number(ratio).toString()}`;
}

module.exports = {
  TARGET_RATIOS,
  buildTargetPrices,
  buildTargetRatioRange,
  formatRatio,
  roundPrice,
};
